import { render } from "./question-info.vue?vue&type=template&id=21e63184&ts=true"
import script from "./question-info.vue?vue&type=script&lang=ts"
export * from "./question-info.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__